import {
  Button,
  Col,
  Dropdown,
  Input,
  Row,
  Select,
  MenuProps,
  Menu,
} from "antd";
import { useState } from "react";
import { Download, Plus } from "lucide-react";
// import { getUserRole } from "../../Utils/Common";

const { Search } = Input;

const PageHeader = (props: any) => {
  const {
    withDateRangeFilter = true,
    withExportToExcelButton = false,
    withExportDropdownButton = false,
    withAddButton = false,
    withCustomButton = false,
    withSearchBtn = true,
    dropdownActions = false,
    dropdownButton = false,
    dropdownWidth = "md:w-[10rem]",
  } = props; //set default values here
  // const role = getUserRole();
  const [term, setTerm] = useState("");

  const handleMenuClick: MenuProps["onClick"] = (e) => {
    if (e.key === "excel") {
      props.onExportToExcel?.();
    } else if (e.key === "pdf") {
      props.onExportToPDF?.();
    }
  };

  const exportMenu: MenuProps["items"] = [
    {
      label: "Excel",
      key: "excel",
    },
    {
      label: "PDF",
      key: "pdf",
    },
  ];

  return (
    <Row className="mb-5" gutter={[20, 10]}>
      <Col xs={24} lg={14} className="header-container text-header">
        {props.title}
      </Col>
      <Col xs={24} lg={10}>
        <div className="w-full flex flex-col md:flex-row gap-3 justify-end mt-3">
          {withSearchBtn && (
            <Search
              className={`${withDateRangeFilter ? "w-full" : "w-[17rem]"}`}
              placeholder="Search"
              onChange={(e) => setTerm(e.target.value)}
              onSearch={() => props.onSearch(term)}
            />
          )}
          {withExportDropdownButton &&
            (props.disableExportButton ? (
              <Button
                icon={<Download size={16} />}
                type="primary"
                className="w-full md:w-auto"
                disabled
              >
                Export
              </Button>
            ) : (
              <Dropdown menu={{ items: exportMenu, onClick: handleMenuClick }}>
                <Button
                  icon={<Download size={16} />}
                  type="primary"
                  className="w-full md:w-auto"
                >
                  Export
                </Button>
              </Dropdown>
            ))}
          {withExportToExcelButton && (
            <Button
              disabled={props.disableExportButton}
              icon={<Download size={16} />}
              type="primary"
              className="w-full md:w-auto"
              onClick={props.onExportToExcel}
            >
              Export to Excel
            </Button>
          )}
          {withAddButton && (
            <Button
              icon={<Plus size={16} />}
              type="primary"
              className="w-full md:w-auto"
              onClick={props.onCreate}
            >
              {`Add ${props.addBtnText ?? ""}`}
            </Button>
          )}
          {withCustomButton && (
            <Button
              icon={props.customIcon}
              type="primary"
              className="w-full md:w-auto"
              onClick={props.onCreate}
            >
              {`${props.customBtnText ?? ""}`}
            </Button>
          )}
          {dropdownActions && (
            <Select
              allowClear
              placeholder="Select action"
              options={props.dropdownOptions}
              onChange={(e) => props.handleSelectChange(e)}
              className={`w-full ${dropdownWidth}`}
            />
          )}
          {dropdownButton && props.dropdownOptions?.length > 0 && (
            <Dropdown
              overlay={
                <Menu
                  onClick={({ key }) => props.handleSelectChange?.(key)}
                  items={props.dropdownOptions.map((opt: any) => ({
                    key: opt.value,
                    label: opt.label,
                  }))}
                />
              }
              placement="bottomRight"
            >
              <Button
                icon={<Plus size={16} />}
                type="primary"
                className="w-full md:w-auto"
                onClick={props.onCreate}
              >
                {`Add ${props.addDropdownBtnText ?? ""}`}
              </Button>
            </Dropdown>
          )}
        </div>
      </Col>
    </Row>
  );
};

export default PageHeader;
